import { Component, OnInit, output, signal } from "@angular/core"
import { CarouselImageComponent } from "./carousel-image.component"
import { CarouselImage } from "../intro.model"
import { UiInheritDirective } from "ui-inherit"
import { prefersReducedMotionQuery } from "ui-theme"

@Component({
  imports: [
    CarouselImageComponent,
    UiInheritDirective,
  ],
  standalone: true,
  template: `
    <div style="width: 30%; height: 70%; position: relative">
      @for (imageObject of imageObjects(); track imageObject.src; let index = $index) {
        <e2e-carousel-image
          [index]="index"
          [carouselIndex]="carouselIndex()"
          [length]="imageObjects().length"
          [imageObject]="imageObject"
          (changeImage)="changeImage.emit($event)"
          inherit
        />
      }
    </div>
  `,
  selector: "e2e-carousel",
})
export class CarouselComponent implements OnInit {
  // imageObjects = input.required<CarouselImage[]>()

  changeImage = output<CarouselImage>()

  carouselIndex = signal(2)

  imageObjects = signal<CarouselImage[]>([
    {
      src: "/assets/pages/intro/carousel/analog-1.png",
      alt: "first carousel",
      thumbnailImageSrc: "",
      title: "",
    },
    {
      src: "/assets/pages/intro/carousel/analog-2.png",
      alt: "second carousel",
      thumbnailImageSrc: "",
      title: "",
    },
    {
      src: "/assets/pages/intro/carousel/analog-3.png",
      alt: "third carousel",
      thumbnailImageSrc: "",
      title: "",
    },
    {
      src: "/assets/pages/intro/carousel/analog-4.png",
      alt: "fourth carousel",
      thumbnailImageSrc: "",
      title: "",
    },
    {
      src: "/assets/pages/intro/carousel/analog-5.png",
      alt: "fifth carousel",
      thumbnailImageSrc: "",
      title: "",
    },
    {
      src: "/assets/pages/intro/carousel/analog-6.png",
      alt: "sixth carousel",
      thumbnailImageSrc: "",
      title: "",
    },
    {
      src: "/assets/pages/intro/carousel/analog-7.png",
      alt: "seventh carousel",
      thumbnailImageSrc: "",
      title: "",
    },
  ])

  ngOnInit() {
    setInterval(() => {
      !prefersReducedMotionQuery.matches && this.rotateCarousel()
    }, 2000)
  }

  rotateCarousel() {
    const array = this.imageObjects()
    array.push(this.imageObjects()[0])
    this.imageObjects.set(array.slice(1))
    /*
        let currentValue = this.carouselIndex() + 1
        if (currentValue > 6) {
          currentValue = 0
        }
        this.carouselIndex.set(currentValue)
    */
  }

  showPrevious(event: any) {
    if (this.carouselIndex() > 0) {
      this.changeImage.emit(this.imageObjects()[this.carouselIndex() - 1])
    }
  }

  showNext(event: any) {
    if (this.carouselIndex() < this.imageObjects().length - 1) {
      this.changeImage.emit(this.imageObjects()[this.carouselIndex() + 1])
    }
  }

}
